import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
    ApiBase_slashless,
    loadLanguages,
    loadTalentDocument,
    saveTalentDocument,
} from '../utils/Network';
import { FromMB, MB, sortLanguages } from '../utils';
import TabsWidget from './shared/dashboard/widgets/TabsWidget';
import VideoGalleryPickerModal from './VideoGalleryPickerModal';

function tutorialVideoPlayableSrc(path) {
    if (path == null || path === '') return '';
    const s = String(path);
    if (/^https?:\/\//i.test(s)) return s;
    const base = String(ApiBase_slashless).replace(/\/$/, '');
    return s.startsWith('/') ? `${base}${s}` : `${base}/${s}`;
}

function tutorialVideoMimeType(path) {
    const p = String(path).toLowerCase();
    if (p.endsWith('.webm')) return 'video/webm';
    if (p.endsWith('.ogg') || p.endsWith('.ogv')) return 'video/ogg';
    if (p.endsWith('.mov')) return 'video/quicktime';
    return 'video/mp4';
}

export default function TalentDocumentContent({ talent_id, document_id, isModal = false, onClose = null, onSaved = null, embedInWidget = false }) {


    const history = useHistory();

    const [Names, setNames] = useState(null);
    const [talentDocument, setTalentDocument] = useState([]);
    const [languages, setLanguages] = useState(null);
    const [expanded, setExpanded] = useState(null);
    const [activeLanguage, setActiveLanguage] = useState(null);


    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hidden_loading, setHiddenLoading] = useState(false);
    const [videoPickerOpen, setVideoPickerOpen] = useState(false);

    useEffect(() => {

        setLoading(true)
        loadLanguages().then(languages => {
            //languages=languages.filter(x=> x.language !==16)
            const sorted = sortLanguages(languages);
            setLanguages(sorted);
            const def = sorted.find(l => l.is_default) || sorted[0];
            if (def) setActiveLanguage(def.id);
        });



        if (document_id) {
            setLoading(true)
            loadTalentDocument(document_id).then(talentDocument => {
                setNames(talentDocument.names)
                setTalentDocument(talentDocument)
                setLoading(false)
            })

        }

        setLoading(false)
    }, [])

    const handleOnChange = (e) => {
        let language_id = e.target.getAttribute("language_id")

        if (language_id) {
            let name = null;
            if (Names) {
                name = Names.find(x => x.language === parseInt(language_id));
            }
            if (name) {
                let temp_talentNames = [...Names];
                temp_talentNames.find(x => x.language === parseInt(language_id)).name = e.target.value;
                setNames(temp_talentNames)
            }
            else {

                let new_name = { name: e.target.value, description: "", language: parseInt(language_id), tutorial_video: "" }
                let temp_talentNamesa = [];
                if (Names)
                    temp_talentNamesa = [...Names, new_name];
                else temp_talentNamesa = [new_name]
                setNames(temp_talentNamesa)
            }
        }
        else {
            switch (e.target.name) {
                case 'max_file_size':
                    talentDocument.max_file_size = MB(e.target.value);
                    setTalentDocument(talentDocument)
                    break;
                case 'extensions':
                    talentDocument.extensions = e.target.value;
                    setTalentDocument(talentDocument)
                    break;
                    
                case 'max_docs':
                    talentDocument.max_docs = e.target.value;
                    setTalentDocument(talentDocument)
                    break;
                default:
                    break;
            }
        }

    }

    const handleDescriptionChange = (language_id, data) => {

        let name = null;
        let temp_names = [];
        if (Names) {
            temp_names = Object.assign(Names);

            name = Names.find(x => x.language === parseInt(language_id));

        }
        if (name) {
            temp_names.find(x => x.language == parseInt(language_id)).description = data
            setNames(temp_names)

        }
        else if (!document_id) {

            let new_name = { name: "", description: data, language: parseInt(language_id), tutorial_video: "" }
            let temp_namesa = [];
            if (Names)
                temp_namesa = [...Names, new_name];
            else temp_namesa = [new_name]
            console.log(temp_namesa)
            setNames(temp_namesa)
        }
    }

    const setTutorialVideoForLanguage = (languageId, filePath) => {
        const lid = parseInt(languageId, 10);
        let temp = Names ? [...Names] : [];
        const row = temp.find((x) => x.language === lid || x.language == lid);
        if (row) {
            row.tutorial_video = filePath || "";
            setNames(temp);
        } else {
            setNames([...temp, { name: "", description: "", language: lid, tutorial_video: filePath || "" }]);
        }
    };

    const clearTutorialVideo = (languageId) => {
        const lid = parseInt(languageId, 10);
        if (!Names) return;
        const temp = [...Names];
        const row = temp.find((x) => x.language === lid || x.language == lid);
        if (row) {
            row.tutorial_video = "";
            setNames(temp);
        }
    };

    const saveChanges = () => {

        setError(false);
        setLoading(true);
        //alert(talentNames[0].name)
        if (!Names || Names[0].name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }


        saveTalentDocument(talent_id, { id: document_id, max_file_size: talentDocument.max_file_size, max_docs: talentDocument.max_docs, names: Names, extensions: talentDocument.extensions })
            .then(function (data) {
                console.log(data)
                setLoading(false)
                if (onSaved) onSaved(data);
            });;
    }

    return (
        <div className={isModal || embedInWidget ? "" : (expanded ? "col-md-12" : "col-md-8")}>
            <div className="cms-dark-box no-border">
                
                <div className="box-body">

                    <div className="row">
                        <div className="col-md-8">
                            <div className="form-group">
                                <TabsWidget
                                    tabs={languages ? languages.map(l => ({ key: l.id, label: l.name, icon: 'fa-globe' })) : []}
                                    activeTab={activeLanguage}
                                    onTabChange={setActiveLanguage}
                                    className="cms-level2-tabs"
                                />
                                <div className="cms-level2-tab-content">
                                    {languages && languages.map((language) => (
                                        activeLanguage === language.id && (() => {
                                            const nameRow = Names && Names.find((x) => x.language == language.id);
                                            const tutorialRaw = (nameRow && nameRow.tutorial_video) || '';
                                            const tutorialSrc = tutorialVideoPlayableSrc(tutorialRaw);
                                            return (
                                            <div key={language.id}>
                                                <div className="form-row">
                                                    <input type="text" name="name" className="form-control mb-10" language_id={language.id} value={Names && Names.find(x => x.language == language.id) ? Names.find(x => x.language == language.id).name : ""} onChange={handleOnChange} placeholder={language.name} />
                                                </div>
                                                <div className={`form-row${language.name.toLowerCase().includes('kurd') ? ' kfont' : ''}`}>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={Names && Names.find(x => x.language == language.id) ? Names.find(x => x.language == language.id).description ? Names.find(x => x.language == language.id).description : "" : ""}
                                                        onReady={editor => { }}
                                                        onChange={(event, editor) => {
                                                            let data = editor.getData();
                                                            handleDescriptionChange(language.id, data)
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-row mt-3">
                                                    <div className="cms-doc-tutorial-video-wrap">
                                                        <div className="cms-doc-tutorial-video">
                                                            <span className="cms-doc-tutorial-video__label">Tutorial video</span>
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                className="form-control input-sm cms-doc-tutorial-video__input"
                                                                value={tutorialRaw}
                                                                placeholder="Not set — pick from library or upload"
                                                                title={tutorialRaw}
                                                            />
                                                            <div className="cms-doc-tutorial-video__actions">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-cm btn-sm cms-doc-tutorial-video__btn-primary"
                                                                    onClick={() => setVideoPickerOpen(true)}
                                                                    title="Open video gallery or upload a new file"
                                                                >
                                                                    <i className="fa fa-film" aria-hidden="true" />
                                                                    <span>Library / Upload</span>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-default btn-sm cms-doc-tutorial-video__btn-clear"
                                                                    onClick={() => clearTutorialVideo(language.id)}
                                                                    title="Remove tutorial video"
                                                                >
                                                                    <i className="fa fa-eraser" aria-hidden="true" />
                                                                    <span>Clear</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {tutorialSrc ? (
                                                            <div className="cms-doc-tutorial-video-preview">
                                                                <video
                                                                    key={tutorialSrc}
                                                                    className="cms-doc-tutorial-video-preview__player"
                                                                    controls
                                                                    playsInline
                                                                    preload="metadata"
                                                                >
                                                                    <source src={tutorialSrc} type={tutorialVideoMimeType(tutorialRaw)} />
                                                                </video>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            );
                                        })()
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="form-group row">
                                    <div className="col-sm-12">
                                        <input type="text" name="max_file_size" className="form-control max-200 " defaultValue={talentDocument && FromMB(talentDocument.max_file_size)} onChange={handleOnChange} placeholder="Max File Size (MB)" />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="form-group row">
                                    <div className="col-sm-12">
                                        <input type="text" name="max_docs" className="form-control max-200" defaultValue={talentDocument && talentDocument.max_docs} onChange={handleOnChange} placeholder="Number Of Documents" />
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="form-group row">
                                    <div className="col-sm-12">
                                        <input type="text" name="extensions" className="form-control max-200" defaultValue={talentDocument && talentDocument.extensions} onChange={handleOnChange} placeholder="File Types" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                   


                </div>

                <div className="box-footer">
                    <button type="button" onClick={saveChanges} disabled={loading} className="btn btn-primary pull-right">Save Changes</button>
                    {isModal && (
                        <button type="button" onClick={onClose} className="btn btn-dark">Cancel</button>
                    )}
                    {!isModal && document_id && !embedInWidget && (<>
                        <a href={`talents/${talent_id}/documents/`} className="btn btn-dark">Cancel</a>
                    </>)}
                </div>
            </div>
            
            {error && (
                <>
                    <div className="alert alert-danger">
                        {error}
                    </div>
                </>
            )}

            {loading && (
                <>
                    <div className="alert alert-info">
                        please wait...
                    </div>
                </>
            )}

            <VideoGalleryPickerModal
                isOpen={videoPickerOpen}
                closeGallery={() => setVideoPickerOpen(false)}
                languageId={activeLanguage}
                onVideoSelected={(path) => setTutorialVideoForLanguage(activeLanguage, path)}
            />
        </div>


    )

}
